module.exports = __webpack_public_path__ + "img/Captura de Pantalla 2021-09-22 a la(s) 10.23.34.png.9befbef7.png";